module.exports = __webpack_public_path__ + "img/payment.e7ff2409.png";